export function decodeFromUrlString(urlLocation: string) {
  return decodeURIComponent(urlLocation)
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}
